<template>
  <div>
    <div class="topOperation clear">
      <span class="platform_common_title">{{ page_name }}</span>
      <div class="screenBox">
        <div class="screenItem">
          <label>已选择</label>
          <div class="itemCon" style="margin-top:4px;width: calc(100% - 55px);">
            <el-tag style="margin:0 5px 10px" :key="index" v-for="(tag, index) in tags"
              :closable="tag.property == 'month' ? false : true" type="success" :disable-transitions='true' size="small"
              @close="handleCloseTag(tag)">
              {{ tag.name + '：' + getDisplayValue(tag) }}
            </el-tag>
          </div>
        </div>
      </div>
    </div>
    <div class="screenBox" v-if="search_array.length > 0">
      <el-input placeholder="请输入任务ID" v-if="search_data.task_id" v-model.trim="search_data.task_id.value" clearable
        @keydown.enter.native="search_data.task_id.value ? selectChange('task_id') : ''" @clear="selectChange('task_id')"
        size="mini" class="input input_other">
        <el-button slot="append" icon="el-icon-search" @click="search_data.task_id.value ? selectChange('task_id') : ''"
          style="padding:0 10px"></el-button>
      </el-input>
      <el-input placeholder="请输入后台订单ID" v-if="search_data.order_part_id" v-model.trim="search_data.order_part_id.value"
        clearable @keydown.enter.native="search_data.order_part_id.value ? selectChange('order_part_id') : ''"
        @clear="selectChange('order_part_id')" size="mini" class="input input_other">
        <el-button slot="append" icon="el-icon-search"
          @click="search_data.order_part_id.value ? selectChange('order_part_id') : ''"
          style="padding:0 10px"></el-button>
      </el-input>
      <el-select v-if="isMonthMore" multiple class="input input_other" v-model="search_data.month.value" size='mini'
        filterable @change="selectMonthChange('more')" placeholder="选择月份">
        <el-option v-for="(item, index) in allMontList" :key="index" :label="item" :value="item">
        </el-option>
      </el-select>
      <el-date-picker v-if="!isMonthMore" class="input input_other" @change="selectMonthChange()"
        v-model="search_data.month.value[0]" type="month" size="mini" :clearable='false' value-format="yyyy-MM"
        placeholder="所属月份">
      </el-date-picker>
      <el-select class="input" multiple v-for="(item, index) in search_array" :key="index" v-model="item.value"
        size='mini' @change="selectChange2(item.label)" filterable :placeholder="item.name">
        <!-- 实际消耗月份 -->
        <template v-if="item.label == 'order_original_month'">
          <el-option v-for="(item, index) in allMontList" :key="index + 'order_original_month'" :label="item"
            :value="item"></el-option>
        </template>
        <template v-else-if="item.label == 'exec_medium'">
          <el-option v-for="(medium, index) in execMediumList" :key="index" :label="medium.real_name" :value="medium.id">
          </el-option>
        </template>
        <template v-else>
          <el-option v-for="(item, index) in condition_data[item.label]" :key="index" :label="item" :value="item">
          </el-option>
        </template>
      </el-select>
      <el-select class="input input_other" v-if="search_data.if_public" v-model="search_data.if_public.value" size='mini'
        @change="selectChange('if_public')" filterable :placeholder="search_data.if_public.name">
        <el-option v-for="(item, index) in if_public_list" :key="index" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
      <el-select class="input input_other" v-if="search_data.is_refund" v-model="search_data.is_refund.value" size='mini'
        @change="selectChange('is_refund')" filterable :placeholder="search_data.is_refund.name">
        <el-option v-for="(item, index) in is_refund_list" :key="index" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
      <div class="smallScreen" v-if="search_data.gross_margin_min && search_data.gross_margin_max">
        <label>利润率(%)</label>
        <el-input size="mini" placeholder="最小值" class="smallInput numberInput"
          v-model="search_data.gross_margin_min.value" style="margin-right:0" clearable>
        </el-input> - <el-input size="mini" placeholder="最大值" style="margin-right:0;" class="smallInput numberInput"
          v-model="search_data.gross_margin_max.value" clearable>
        </el-input>
        <el-button icon="el-icon-search" style="background:#f6f7fa;padding:6px 10px;margin-right:5px;margin-left:-7px;"
          @click="selectChange('gross_margin_min')" size="mini"></el-button>
      </div>
      <div class="smallScreen" v-if="search_data.cost_min && search_data.cost_max">
        <label>订单成本消耗金额</label>
        <el-input size="mini" placeholder="最小值" class="smallInput numberInput" v-model="search_data.cost_min.value"
          style="margin-right:0" clearable>
        </el-input> - <el-input size="mini" placeholder="最大值" style="margin-right:0;" class="smallInput numberInput"
          v-model="search_data.cost_max.value" clearable>
        </el-input>
        <el-button icon="el-icon-search" style="background:#f6f7fa;padding:6px 10px;margin-right:5px;margin-left:-7px;"
          @click="selectChange('cost_min')" size="mini"></el-button>
      </div>
      <div class="smallScreen" v-if="search_data.top_fee_max && search_data.top_fee_min">
        <label>置顶费</label>
        <el-input size="mini" placeholder="最小值" class="smallInput numberInput" v-model="search_data.top_fee_min.value"
          style="margin-right:0" clearable>
        </el-input> - <el-input size="mini" placeholder="最大值" style="margin-right:0;" class="smallInput numberInput"
          v-model="search_data.top_fee_max.value" clearable>
        </el-input>
        <el-button icon="el-icon-search" style="background:#f6f7fa;padding:6px 10px;margin-right:5px;margin-left:-7px;"
          @click="selectChange('top_fee_min')" size="mini"></el-button>
      </div>
      <div class="smallScreen" v-if="search_data.actual_cost_sum_max && search_data.actual_cost_sum_min">
        <label>后台实付成本金额</label>
        <el-input size="mini" placeholder="最小值" class="smallInput numberInput"
          v-model="search_data.actual_cost_sum_min.value" style="margin-right:0" clearable>
        </el-input> - <el-input size="mini" placeholder="最大值" style="margin-right:0;" class="smallInput numberInput"
          v-model="search_data.actual_cost_sum_max.value" clearable>
        </el-input>
        <el-button icon="el-icon-search" style="background:#f6f7fa;padding:6px 10px;margin-right:5px;margin-left:-7px;"
          @click="selectChange('actual_cost_sum_min')" size="mini"></el-button>
      </div>
      <div class="smallScreen" v-if="search_data.amount_min && search_data.amount_max">
        <label>订单金额</label>
        <el-input size="mini" placeholder="最小值" class="smallInput numberInput" v-model="search_data.amount_min.value"
          style="margin-right:0" clearable>
        </el-input> - <el-input size="mini" placeholder="最大值" class="smallInput numberInput" style="margin-right:0;"
          v-model="search_data.amount_max.value" clearable>
        </el-input>
        <el-button icon="el-icon-search" style="background:#f6f7fa;padding:6px 10px;margin-right:5px;margin-left:-7px;"
          @click="selectChange('amount_min')" size="mini"></el-button>
      </div>
      <div class="smallScreen" v-if="search_data.final_amount_min && search_data.final_amount_max">
        <label>订单最终收入</label>
        <el-input size="mini" placeholder="最小值" class="smallInput numberInput"
          v-model="search_data.final_amount_min.value" style="margin-right:0" clearable>
        </el-input> - <el-input size="mini" placeholder="最大值" style="margin-right:0;" class="smallInput numberInput"
          v-model="search_data.final_amount_max.value" clearable>
        </el-input>
        <el-button icon="el-icon-search" style="background:#f6f7fa;padding:6px 10px;margin-right:5px;margin-left:-7px;"
          @click="selectChange('final_amount_min')" size="mini"></el-button>
      </div>
      <el-select class="input input_other" v-if="search_data.statements_status"
        v-model="search_data.statements_status.value" size='mini' @change="selectChange('statements_status')" filterable
        :placeholder="search_data.statements_status.name">
        <el-option v-for="(item, index) in statements_status_list" :key="index" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
      <!-- 回款日期筛选 -->
      <div class="smallScreen" v-if="search_data.date_of_collection && (userInfo.role_id == 12 || userInfo.role_id == 10
       || userInfo.role_id == 15 || userInfo.role_id == 18 || userInfo.admin_id == 53)">
        <label class="label_name mb-10">回款日期：</label>
        <el-date-picker class="mb-10" @change="selectChange('date_of_collection')" style="width:240px" 
          v-model="search_data.date_of_collection.value" type="daterange" value-format="yyyy-MM-dd" size='mini' range-separator="至" 
          start-placeholder="开始日期" end-placeholder="结束日期">
        </el-date-picker>
      </div>  
      <el-select class="input input_other" v-if="search_data.verify_status" v-model="search_data.verify_status.value"
        size='mini' @change="selectChange('verify_status')" filterable :placeholder="search_data.verify_status.name">
        <el-option v-for="(item, index) in verify_status_list" :key="index" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
      <!-- <button class="button" @click="goSearch()">搜索</button> -->
      <button class="button" @click="resetData()">重置</button>
    </div>
  </div>
</template>
<script>
export default {
  props: ['page_name', 'timeMonth', 'source'],
  data () {
    return {
      tags: [],
      userInfo: [],
      condition_data: {},
      search_data: {
      },
      cost_search: {
        search_object: {
          task_id: { value: '', name: '任务ID' },
          month: { value: [this.timeMonth], name: '月份' },
          order_part_id: { value: '', name: '后台订单ID' },
          if_public: { value: '', name: '是否对公' },
          is_refund: { name: '是否返货', value: '' }
        },
        array: [
          { label: 'advertiser_id', value: [], name: '账户ID', },
          { label: 'advertiser_account', value: [], name: '账户名称', },
          { label: 'internet_celebrity_name', value: [], name: '网红名', },
          { label: 'company', value: [], name: '签约公司', },
          { label: 'project_name', value: [], name: '项目名称', },
          { label: 'media_name', value: [], name: '媒体名称', },
          { label: 'salesman', value: [], name: '销售', },
          { label: 'handler', value: [], name: '经手人', },
          { label: 'customer_name', value: [], name: '客户全称', },
          { label: 'launch_platform', value: [], name: '所属平台', },
          { label: 'offline_subsidy_company', value: [], name: '线下补款公司', },
          { label: 'cost_company_name', value: [], name: '成本公司全称', },
          { label: 'cost_owner', value: [], name: '成本负责人', },
          { label: 'exec_medium', value: [], name: '执行媒介', },
          { label: 'ratio_of_consumption_to_top_rebate', value: [], name: '预估总消耗与置顶返点比例', },
          { label: 'flow_boost_rebate_ratio', value: [], name: '预估总流量助推返点比例', },
        ]
      },
      total_search: {
        search_object: {
          task_id: { value: '', name: '任务ID' },
          month: { value: [this.timeMonth], name: '月份' },
          order_part_id: { value: '', name: '后台订单ID' },
          if_public: { value: '', name: '是否对公' },
          is_refund: { name: '是否返货', value: '' },
          gross_margin_max: { value: '', name: '利润率最大值' },
          gross_margin_min: { value: '', name: '利润率最小值' },
          cost_max: { value: '', name: '订单成本消耗金额最大值' },
          cost_min: { value: '', name: '订单成本消耗金额最小值' },
          top_fee_max: { value: '', name: '置顶费最大值' },
          top_fee_min: { value: '', name: '置顶费最小值' },
          actual_cost_sum_max: { value: '', name: '后台实付成本金额最大值' },
          actual_cost_sum_min: { value: '', name: '后台实付成本金额最小值' },
          date_of_collection: { value: '', name: '回款日期'},
        },
        array: [
          { label: 'order_original_month', value: [], name: '实际消耗月份', },
          { label: 'advertiser_id', value: [], name: '账户ID', },
          { label: 'advertiser_account', value: [], name: '账户名称', },
          { label: 'internet_celebrity_name', value: [], name: '网红名', },
          { label: 'company', value: [], name: '签约公司', },
          { label: 'project_name', value: [], name: '项目名称', },
          { label: 'media_name', value: [], name: '媒体名称', },
          { label: 'salesman', value: [], name: '销售', },
          { label: 'handler', value: [], name: '经手人', },
          { label: 'customer_name', value: [], name: '客户全称', },
          { label: 'launch_platform', value: [], name: '所属平台', },
          { label: 'offline_subsidy_company', value: [], name: '线下补款公司', },
          { label: 'cost_company_name', value: [], name: '成本公司全称', },
          { label: 'cost_owner', value: [], name: '成本负责人', },
          { label: 'exec_medium', value: [], name: '执行媒介', },
          { label: 'ratio_of_consumption_to_top_rebate', value: [], name: '预估总消耗与置顶返点比例', },
          { label: 'flow_boost_rebate_ratio', value: [], name: '预估总流量助推返点比例', },
          { label: 'launch_start_date', value: [], name: '投放起始日期', },
          { label: 'launch_end_date', value: [], name: '投放截止日期', },
          { label: 'mcn_name', value: [], name: 'mcn机构名称', },
          { label: 'mcn_user', value: [], name: 'mcn负责人', },
          { label: 'mcn_handler', value: [], name: 'mcn经手人', },
        ]
      },
      offline_search: {
        search_object: {
          task_id: { value: '', name: '任务ID' },
          month: { value: [this.timeMonth], name: '月份' },
          order_part_id: { value: '', name: '后台订单ID' },
        },
        array: [
          { label: 'advertiser_id', value: [], name: '账户ID', },
          { label: 'advertiser_account', value: [], name: '账户名称', },
          { label: 'internet_celebrity_name', value: [], name: '网红名', },
          { label: 'company', value: [], name: '签约公司', },
          { label: 'project_name', value: [], name: '项目名称', },
          { label: 'media_name', value: [], name: '媒体名称', },
          { label: 'salesman', value: [], name: '销售', },
          { label: 'handler', value: [], name: '经手人', },
          { label: 'customer_name', value: [], name: '客户全称', },
          { label: 'launch_platform', value: [], name: '所属平台', },
          { label: 'offline_subsidy_company', value: [], name: '线下补款公司', },
          { label: 'offline_celeb_name', value: [], name: '收款人姓名', },
          { label: 'offline_pay_date', value: [], name: '付款时间', },
        ]
      },
      income_search: {
        search_object: {
          task_id: { value: '', name: '任务ID' },
          month: { value: this.timeMonth, name: '月份' },
          order_part_id: { value: '', name: '后台订单ID' },
          if_public: { value: '', name: '是否对公' },
          amount_min: { value: '', name: '订单金额最小值' },
          amount_max: { value: '', name: '订单金额最大值' },
          final_amount_min: { value: '', name: '订单最终收入最小值' },
          final_amount_max: { value: '', name: '订单最终收入最大值' },
          statements_status: { value: '', name: '销售结算单状态' },
          verify_status: { value: '', name: '锁单后审核状态' }
        },
        array: [
          { label: 'advertiser_id', value: [], name: '账户ID', },
          { label: 'advertiser_account', value: [], name: '账户名称', },
          { label: 'internet_celebrity_name', value: [], name: '网红名', },
          { label: 'company', value: [], name: '签约公司', },
          { label: 'project_name', value: [], name: '项目名称', },
          { label: 'media_name', value: [], name: '媒体名称', },
          { label: 'handler', value: [], name: '经手人', },
          { label: 'customer_name', value: [], name: '客户全称', },
          { label: 'launch_platform', value: [], name: '所属平台', },
          { label: 'cost_company_name', value: [], name: '成本公司全称', },
          { label: 'cost_owner', value: [], name: '成本负责人', },
          { label: 'rebate_expense_receiving_unit', value: [], name: '返点支出收款单位', },
        ]
      },
      mcn_search: {
        search_object: {
          task_id: { value: '', name: '任务ID' },
          month: { value: this.timeMonth, name: '月份' },
          order_part_id: { value: '', name: '后台订单ID' },
          statements_status: { value: '', name: 'MCN结算单状态' },
          verify_status: { value: '', name: '锁单后审核状态' }
        },
        array: [
          { label: 'advertiser_id', value: [], name: '账户ID', },
          { label: 'advertiser_account', value: [], name: '账户名称', },
          { label: 'internet_celebrity_name', value: [], name: '网红名', },
          { label: 'company', value: [], name: '签约公司', },
          { label: 'project_name', value: [], name: '项目名称', },
          { label: 'media_name', value: [], name: '媒体名称', },
          { label: 'handler', value: [], name: '经手人', },
          { label: 'customer_name', value: [], name: '客户全称', },
          { label: 'launch_platform', value: [], name: '所属平台', },
          { label: 'cost_company_name', value: [], name: '成本公司全称', },
          { label: 'cost_owner', value: [], name: '成本负责人', },
          { label: 'mcn_handler', value: [], name: 'mcn经手人', },
          { label: 'mcn_name', value: [], name: 'mcn机构名称', },
        ]
      },
      search_array: [],
      statements_status_list: [
        { label: '未申请', value: -1 }, { label: '待商务审核', value: 1 }, { label: '待财务审核', value: 2 }, { label: '商务审核驳回', value: 3 }, { label: '财务审核通过', value: 4 }, { label: '财务审核驳回', value: 5 }
      ],
      verify_status_list: [
        { label: '待媒介审核', value: 1 }, { label: '待财务审核', value: 2 }, { label: '媒介审核驳回', value: 3 }, { label: '财务审核通过', value: 4 }, { label: '财务审核驳回', value: 5 },
      ],
      if_public_list: [
        { label: '不限', value: '不限', }, { label: '对公', value: '是' }
      ],
      is_refund_list: [
        { label: '不限', value: '不限' }, { label: '返货', value: '是' }
      ],
      isMonthMore: false,
      allMontList: [],
      execMediumList: []
    }
  },
  created () {
    if (this.source == 'income' || this.source == 'mcn' || this.source == 'total') {
      this.getAllMontListEvent()
      this.isMonthMore = true;
    }
    var timeMonth = []
    if (Array.isArray(this.timeMonth)) {
      timeMonth = this.timeMonth
    } else {
      timeMonth = [this.timeMonth]
    }
    this.tags = [{
      property: 'month',
      name: '月份',
      values: timeMonth
    }]
    if (this.source == 'total') {
      this.search_data = this.total_search.search_object
      this.search_array = this.total_search.array
    }
    if (this.source == 'cost') {
      this.search_data = this.cost_search.search_object
      this.search_array = this.cost_search.array
    }
    if (this.source == 'offline' || !this.source) {
      this.search_data = this.offline_search.search_object
      this.search_array = this.offline_search.array
    }
    if (this.source == 'income') {
      this.search_data = this.income_search.search_object
      this.search_array = this.income_search.array
    }
    if (this.source == 'mcn') {
      this.search_data = this.mcn_search.search_object
      this.search_array = this.mcn_search.array
    }
    this.getCondition();
    this.getExecMediumList(); // 获取执行媒介列表
  },
  mounted () {
    this.userInfo = JSON.parse(this.$cookie.getCookie('userInfo'));
  },
  watch: {
    execMediumList: {
      handler(newVal, oldVal) {
        // 执行媒介列表变化时的处理逻辑
      },
      immediate: true
    }
  },
  methods: {
    resetData (status) {
      this.tags = [{
        property: 'month',
        name: '月份',
        values: status == 'change' ? this.search_data.month.value : this.timeMonth
      }]
      this.search_array.forEach((item) => {
        item.value = ''
      })
      for (var i in this.search_data) {
        if (i != 'month') {
          this.search_data[i].value = '';
        }
      }
      this.goSearch()
    },
    selectMonthChange (source) {
      if (source == 'more') {
        if (this.search_data.month.value.length < 1) {
          this.search_data.month.value = this.tags.filter((v) => {
            return v.property == 'month'
          })[0].values;
          this.$message({
            message: '月份筛选至少存在一个月份！',
            type: 'warning'
          })
          return;
        }
        this.tags.forEach((item) => {
          if (item.property == 'month') {
            item.values = this.search_data.month.value
          }
        })
      } else {
        this.selectChange('month')
      }
      this.getCondition();
      this.resetData('change')
    },
    selectChange2 (name) {
      var data = this.search_array.filter((v) => {
        return v.label == name
      })[0]
      var arr = this.tags.filter((v) => {
        return v.property == name
      })
      
      // 处理执行媒介的特殊显示逻辑
      let displayValues = data.value
      if (name === 'exec_medium' && data.value && data.value.length > 0) {
        // 将ID转换为对应的名称用于显示
        displayValues = data.value.map(id => {
          const medium = this.execMediumList.find(item => item.id == id)
          return medium ? medium.real_name : id
        })
      }
      
      if (arr.length > 0) {
        if (!data.value || data.value.length == 0) {
          this.tags = this.tags.filter((v) => {
            return v.property != data.label
          })
        } else {
          this.tags.forEach((item) => {
            if (item.property == name) {
              // 对于执行媒介，存储ID用于API调用，但显示名称
              item.values = name === 'exec_medium' ? data.value : displayValues
            }
          })
        }

      } else {
        if (data.value && data.value.length > 0) {
          this.tags.push({
            property: data.label,
            name: data.name,
            // 对于执行媒介，存储ID用于API调用，但显示名称
            values: name === 'exec_medium' ? data.value : displayValues
          })
        }
      }
      this.goSearch()
    },
    selectChange (name) {
      var data = this.search_data[name];
      var arr = this.tags.filter((v) => {
        return v.property == name
      })
      if (arr.length > 0) {
        if (data.value == '') {
          this.tags = this.tags.filter((v) => {
            return v.property != name
          })
        } else {
          this.tags.forEach((item) => {
            if (item.property == name) {
              item.values = data.value
            }
          })
        }
        if (name != 'month' && name != 'amount_min' && name != 'final_amount_min' && name != 'gross_margin_min' && name != 'cost_min' && name != 'top_fee_min' && name != 'actual_cost_sum_min') {
          this.goSearch()
        }
      } else {
        if (name.indexOf('min') != -1 || name.indexOf('max') != 1 || data.value != '') {
          this.tags.push({
            property: name,
            name: data.name,
            values: data.value
          })
          if (name != 'amount_min' && name != 'final_amount_min' && name != 'gross_margin_min' && name != 'cost_min' && name != 'top_fee_min' && name != 'actual_cost_sum_min') {
            this.goSearch()
          }
        }
      }
      if (name == 'amount_min') {
        this.selectChange('amount_max')
      }
      if (name == 'final_amount_min') {
        this.selectChange('final_amount_max')
      }
      if (name == 'gross_margin_min') {
        this.selectChange('gross_margin_max')
      }
      if (name == 'cost_min') {
        this.selectChange('cost_max')
      }
      if (name == 'top_fee_min') {
        this.selectChange('top_fee_max')
      }
      if (name == 'actual_cost_sum_min') {
        this.selectChange('actual_cost_sum_max')
      }
    },
    handleCloseTag (val) {//关闭标签
      this.tags = this.tags.filter((v) => {
        return v.property != val.property
      })
      this.search_array.forEach((item) => {
        if (item.label == val.property) {
          item.value = '';
        }
      });
      for (var i in this.search_data) {
        if (i == val.property) {
          this.search_data[i].value = ''
        }
      }
      this.goSearch()
    },
    goSearch () {
      var tags = JSON.parse(JSON.stringify(this.tags))
      if (!this.isMonthMore) {
        tags.forEach((item) => {
          if (item.property == 'month') {
            if (Array.isArray(item.values)) {
              item.values = item.values[0]
            }
          }
        })
      }
      this.$emit('search_event', tags)
    },
    getCondition () {//获取搜索条件接口
      console.log('getCondition方法被调用');
      this.$axios.get(this.URL.BASEURL + this.URL.allColumnSearchSecond, {
        params: {
          month: this.search_data.month.value,
        }
      }).then((res) => {
        var res = res.data;
        console.log('getCondition接口响应:', res);
        if (res && res.errno == 0) {
          var data = res.rst;
          console.log('getCondition返回的数据:', data);
          this.condition_data = data;
          console.log('condition_data已设置:', this.condition_data);
        } else {
          console.log('getCondition接口返回错误:', res.err);
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch((error) => {
        console.log('getCondition接口请求失败:', error);
      })
    },
    getAllMontListEvent () {
      this.$axios.get(this.URL.BASEURL + this.URL.getAllMontList, {
      }).then((res) => {
        var res = res.data;
        if (res && res.errno == 0) {
          var data = res.rst;
          this.allMontList = data;
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
      })
    },
    // 获取执行媒介列表
    getExecMediumList() {
      this.$axios.get(this.URL.BASEURL + this.URL.getExecMediumList).then((res) => {
        if (res && res.data && res.data.errno == "0") {
          var data = res.data.rst;
          this.execMediumList = data;
        } else {
          this.$message({
            message: res.data ? res.data.err : '获取执行媒介列表失败',
            type: 'warning'
          })
        }
      }).catch((error) => {
        console.log('执行媒介接口请求失败:', error);
      })
    },
    // 获取标签显示值
    getDisplayValue(tag) {
      if (tag.property === 'exec_medium' && Array.isArray(tag.values)) {
        // 对于执行媒介，将ID转换为名称显示
        return tag.values.map(id => {
          const medium = this.execMediumList.find(item => item.id == id)
          return medium ? medium.real_name : id
        }).join(', ')
      }
      return Array.isArray(tag.values) ? tag.values.join(', ') : tag.values
    }
  }
}
</script>
<style lang="scss" scoped>
.topOperation {
  display: flex;
  align-items: top;

  .screenBox {
    flex: 1;
  }
}

.screenItem {
  display: flex;
  align-items: baseline;
  margin-left: 10px;

  label {
    font-size: 14px;
    font-weight: bold;
    color: #555;
  }
}

.input {
  width: 140px;
  margin-right: 5px;
  margin-top: 5px;
}

.input_other {
  margin-right: 0;
}

.button {
  background: #FF9B3B;
  padding: 4px 8px;
  font-size: 12px;
  border: none;
  border-radius: 3px;
  color: #fff;
  font-weight: bold;
}

.smallScreen {
  display: inline-block;
  margin-bottom: 5px;

  label {
    text-align: right;
    min-width: 40px;
    width: auto;
    line-height: 20px;
    font-size: 12px;
    vertical-align: baseline;
  }

  .smallInput {
    width: 70px;
    vertical-align: baseline;
    margin-right: 10px;
  }
}
</style>
<style lang="scss">
.smallScreen .el-input__inner {
  padding: 0 !important;
  text-align: center !important;
}

.screenBox .el-input--suffix .el-input__inner {
  padding-right: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Order/searchTemplate.vue